<ngx-dropzone (change)="onSelect($event)" [accept]="accept" [disabled]="disabled" [multiple]="multiple" style="height: 140px;">
  <ngx-dropzone-label>
    <div fxLayout="column" fxLayoutAlign="center center">
      <img
        alt="upload file"
        src="/assets/icons/upload-file.svg"
        style="width: 32px; height: 32px"
      />
      <div class="fs-sm fw-semi-b" style="color: #3d3d3d">Upload Here</div>
      <div style="color: #99a1af; font-size: 10px">{{ formattedAccept }} up to {{ maxSize }}MB</div>
    </div>
  </ngx-dropzone-label>
  <ngx-dropzone-preview
    (removed)="onRemove(f)"
    *ngFor="let f of files"
    [removable]="true"
  >
    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
  </ngx-dropzone-preview>
</ngx-dropzone>
